/* eslint-disable no-console */
export default class ConsoleLogger {

  static log(message) {
    console.log(message);
  }

  static error(message) {
    console.error(message);
  }
}



// WEBPACK FOOTER //
// ./src/ConsoleLogger.js